import axios from 'axios';

export const ManangerAPI = axios.create({
  baseURL: `${process.env.REACT_APP_MANAGER_API_BASE_URL}`,
  timeout: 30000,
  headers: {
    'content-type': 'application/json',
    Authorization: `Basic ${process.env.REACT_APP_MANAGER_API_BASIC_TOKEN}`,
  },
});

ManangerAPI.interceptors.response.use((response) => {
  return response.data.data;
});

export const createPlaidToken = (payload: any) =>
  ManangerAPI.post('/plaid/create_link_token', payload);

export const createLinkTokenForUpdateItem = (payload: any) =>
  ManangerAPI.post('/plaid/create_link_token_for_update_item', payload);

export const createIdentityVerificationLinkToken = (payload: any) =>
  ManangerAPI.post('/plaid/create_identity_verification_link_token', payload);

export const updatePlaidUpdateMode = (payload: any) =>
  ManangerAPI.post('/plaid/update_plaid_update_mode', payload);

export const addPlaidIdentityVerification = (payload: any) =>
  ManangerAPI.post('/plaid/add_identity_verification', payload);

export const addIdentityMatch = (
  plaid_access_token: string,
  identity_verification_pk: number,
) =>
  ManangerAPI.post('/plaid/add-identity-match', {
    plaid_access_token,
    identity_verification_pk,
  });

export const exchangePublicToken = (payload: any) =>
  ManangerAPI.post('/plaid/exchange_public_token', payload);

export const addPlaidLinkCallback = (payload: any) =>
  ManangerAPI.post('/plaid/add-plaid-link-callback', payload);

export const createCustomer = (payload: any) =>
  ManangerAPI.post('/services/customers', payload);

export const getCustomer = (customerId: string) =>
  ManangerAPI.post('/services/getCustomer', {
    CustomerPK: null,
    CustomerID: customerId,
    ContactID: null,
  });

export const getGUIDValidation = (guid: string) =>
  ManangerAPI.post('/contact-server/guid-validation', { guid });

export const send2FACode = (guid: string, isEmailSend: boolean) =>
  ManangerAPI.post('/contact-server/send-2fa', { guid, isEmailSend });

export const verifyCode = (guid: string, code: string) =>
  ManangerAPI.post('/contact-server/verify-2fa', { guid, code });

export const getPaymentPreferences = () =>
  ManangerAPI.post('/contact-server/get-payment-preferences');

export const getOrganizationSettings = (
  organization_pk: string,
  app: string,
  section: string,
) =>
  ManangerAPI.post('/contact-server/get-organization-settings', {
    organization_pk,
    app,
    section,
  });

export const getOrganizationSettingsSection = (customer_pk: number) =>
  ManangerAPI.post('/contact-server/get-organization-settings-section', {
    customer_pk,
  });

export const updatePaymentPreferences = (
  customerPk: number,
  paymentPreferencePk: number,
) =>
  ManangerAPI.post('/contact-server/update-payment-preferences', {
    customerPk,
    paymentPreferencePk,
  });

export const getIDVAuth = (user_pk: string, invite_pk: string | null) =>
  ManangerAPI.post('/contact-server/idv/get-auth', { user_pk, invite_pk });

export const createIDVCustomer = (
  organization_pk: string,
  user_pk: string,
  invite_pk: string | null,
) =>
  ManangerAPI.post('/contact-server/idv/create-idv-customer', {
    organization_pk,
    user_pk,
    invite_pk,
  });

export const createDwollaContact = (customer_pk: string) =>
  ManangerAPI.post('/contact-server/idv/create-dwolla-contact', {
    customer_pk,
  });

export const getOrganizationSettingsName = (
  organization_pk: string,
  settings_name: string,
) =>
  ManangerAPI.post('/contact-server/idv/get-organization-settings-name', {
    organization_pk,
    settings_name,
  });

export const getTiflePolicies = (payload: any) =>
  ManangerAPI.post('/user/policies', payload);

export const addUpdateCustomerWireTransferSettings = (payload: any) =>
  ManangerAPI.post(
    '/contact-server/add-update-customer-wire-tranfer-settings',
    payload,
  );
export const validateTransferReceiptAuth = (payload: any) =>
  ManangerAPI.post('/contact-server/validate-transfer-receipt-auth', payload);

export const getContactTransferReceipt = (transfer_pk: number) =>
  ManangerAPI.post('/contact-server/get-transfer-receipt', { transfer_pk });

export const getTransferReceiptOrganization = (guid: string) =>
  ManangerAPI.post('/contact-server/get-transfer-receipt-organization', {
    guid,
  });

export const getContactShareOrganization = (guid: string) =>
  ManangerAPI.post('/contact-server/get-contact-share-organization', {
    guid,
  });
export const validateContactShareAuth = (payload: any) =>
  ManangerAPI.post('/contact-server/validate-contact-share-auth', payload);

export const getCustomerOrganizationRequest = (payload: any) =>
  ManangerAPI.post(
    '/contact-server/get-customer-organization-request',
    payload,
  );

export const addUpdateDwollaCustomerOrganizationRequest = (payload: any) =>
  ManangerAPI.post(
    '/contact-server/add-update-dwolla-customer-organization-request',
    payload,
  );
